import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { oktaConfigAsync } from "./authConfig";
import SessionInfo from "./SessionDataTracker";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { useOktaAuth, Security } from "@okta/okta-react";

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);

oktaConfigAsync().then((oktaConfig: any) => {
    SessionInfo.config = oktaConfig;
    const oktaAuth = new OktaAuth(oktaConfig as Object);

    ReactDOM.render(
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <Security oktaAuth={oktaAuth} onAuthRequired={() => {}} restoreOriginalUri={(auth: any, originalUri: any) => {}}>
                    <App/>
                </Security>
            </ConnectedRouter>
        </Provider>,
        document.getElementById("root"));

    registerServiceWorker();
});
